import PoliciesComponentContainer from './PoliciesComponentContainer';

export default PoliciesComponentContainer;
